import { useTranslation } from "react-i18next";
import { useLocale } from "../../hooks/useLocale";
import { localName, money } from "../../lib/format";
import type { Product } from "../../lib/types";

interface Props {
  packages: Product[];
  value: string;
  onChange: (id: string) => void;
  perStudent: boolean;
}

export function PackagePicker({ packages, value, onChange, perStudent }: Props) {
  const { t } = useTranslation();
  const { locale } = useLocale();
  return (
    <div>
      <span className="label">{t("booking.selectPackage")}</span>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-3" role="radiogroup" aria-label={t("booking.selectPackage")}>
        {packages.map((p) => {
          const on = p.id === value;
          return (
            <button key={p.id} type="button" role="radio" aria-checked={on} onClick={() => onChange(p.id)}
              className={`rounded-2xl border-2 p-3 text-start transition ${on ? "border-cosmic-purple bg-purple-50/40" : "border-gray-200 hover:border-cosmic-purple"}`}>
              <div className="mb-1 text-xs font-extrabold text-cosmic-navy">{localName(p, locale)}</div>
              <div className="num font-mono text-xs font-black text-cosmic-purple">
                {money(p.price)} {t("currency")}{perStudent ? ` ${t("booking.perStudent")}` : ""}
              </div>
              {p.durationMinutes && <div className="mt-1 text-[10px] text-gray-500">{t("booking.playTime", { minutes: p.durationMinutes })}</div>}
            </button>
          );
        })}
      </div>
    </div>
  );
}
